import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppTextService {
  constructor(
    private http: HttpClient,
    @Inject('env') private env: any
  ) {}

  public getAppText(name: string, locale: string = 'en-US'): Observable<string> {
    return this.http.get<string>(`${this.env.apiUrlRoot}/AppText/${name}/${locale}`);
  }
}
